import {Api} from './api';

const IGNORE_STATES = [
  'SET_STATE',
  'SET_STATISTICS',
  'SET_LOADING'
];

export const updateActivity = store => next => action => {
  let result = next(action)
  let projectId = store.getState().get('id');
  if(IGNORE_STATES.indexOf(action.type) === -1 && projectId) {
    Api.get(`/api/projects/${projectId}/activity`).then(json => {
      store.dispatch({type: 'SET_STATE', state: json});
    });
  }
  return result
}

// this just throws a more user-friendly error so it can
// bubble to the UI if there is a bug in the codebase
export const catchErrors = store => next => action => {
  try {
    return next(action); // dispatch
  } catch (err) {
    console.log(err);
    throw Error('An unexpected error occurred.');
  }
}

// we should only allow errors if they are set through that action
export const setNoErrors = store => next => action => {
  if(action.type === 'SET_STATE' && !action.state['error']) {
    action.state['error'] = null;
  }
  return next(action);
}
